const styles = {
  wrapFields: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 1,
  },
}

export default styles
